import { getAllFloorPlansGui } from '@api/services/sitewalk-gui.service';
import useDataQuery from '@hooks/use-data-query';

interface IFloorPlanListOptions {
    clientId: string;
    projectId: string;
}

const useFloorPlanGuiListData = (props: IFloorPlanListOptions) => {
    const { clientId, projectId } = props;

    const floorPlanListQuery = useDataQuery(['floor-plans-gui', clientId, projectId], () =>
        getAllFloorPlansGui(clientId, projectId)
    );

    return {
        floorPlansGui: floorPlanListQuery.data,
        isLoading: floorPlanListQuery.isLoading,
        setData: floorPlanListQuery.setData,
        refetch: floorPlanListQuery.refetch,
    };
};

export default useFloorPlanGuiListData;
